import React, { useEffect } from 'react';
import { RHTextField } from '../../../../../../../dum';
import { IOrderQuotation } from '../../order-quotation-form';
import { useFormContext, useWatch } from 'react-hook-form';
import { useGetOrderQuotationMaxOrderCodeQuery } from '../../../../../../../../services';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

const ID_FIELD_NAME: keyof IOrderQuotation = 'id';

export function OrderCodeInput() {
    const INPUT_NAME: keyof IOrderQuotation = 'order_code';
    const orderQuotationId = useWatch({
        name: ID_FIELD_NAME,
    }) as IOrderQuotation['id'];
    // Cotizaciones get their OWN code sequence, independent of pedidos.
    const { data } = useGetOrderQuotationMaxOrderCodeQuery();
    const formContext = useFormContext();

    useEffect(() => {
        if (orderQuotationId || !data) {
            return;
        }
        // Seed the suggested folio (max + 1) ONLY while the field is still empty
        // — i.e. a fresh create form the user hasn't typed into. Without this
        // guard the effect re-ran on every render (react-hook-form's context is a
        // new reference each time) and kept overwriting whatever the user typed,
        // snapping the folio back to max + 1: that was the "folio resets" bug and
        // why a manually entered value (e.g. 1) could never stick.
        const current = formContext.getValues(INPUT_NAME);
        if (!current) {
            formContext.setValue(
                INPUT_NAME,
                data.getOrderQuotationMaxOrderCode + 1,
                {
                    // setValue does not validate programmatic values by
                    // default. Check the suggested folio immediately too, not
                    // only values the user types or the eventual submit.
                    shouldValidate: true,
                    shouldDirty: false,
                },
            );
        }
    }, [orderQuotationId, data, formContext]);

    return (
        <RHTextField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.order_code)}
        />
    );
}
